import React from 'react';
import { useSelector } from 'react-redux';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import TransitionPage from 'js/containers/transition/Transition.page';

// stack component
import CollectionViewCollection from 'js/containers/stack/collection/Collection.view-collection';
import LoadingIcon from 'js/components/generic/Generic.loading-icon';

// import selectors
import { getSiteMetaData } from 'js/store/app/App.selectors';

const MAX_QUERY_LENGTH = 2950;

const isValidData = (value) => {
  return typeof value === 'object' && value !== null;
};

const PageShare = ({ path }) => {
  const [data, setData] = React.useState(false);
  const cardData = useSelector((state) => state.cards.byId);
  const siteMetaData = useSelector((state) => getSiteMetaData(state, path));

  React.useEffect(() => {
    setBodyBackgroudColor('#BBDCD5');

    if (typeof window === 'undefined') return;

    try {
      const searchParams = new URLSearchParams(window.location.search);
      const dataParam = searchParams.get('data');

      if (!dataParam || dataParam.length > MAX_QUERY_LENGTH) {
        return;
      }

      const parsed = JSON.parse(dataParam);

      if (isValidData(parsed)) {
        setData(parsed);
        console.log('Safe dataParam:', parsed);
      } else {
        console.warn('Query param failed validation');
      }
    } catch (error) {
      console.error('Invalid data query param', error);
    }
  }, []);

  const getCardDataFromCollection = (collectionData) => {
    if (!collectionData || !collectionData.cards) return null;

    return {
      ...collectionData,
      cards: collectionData.cards
        .map((id) => {
          return cardData[id] || false;
        })
        .filter((card) => card), // Filter out any cards that weren't found in the state,
    };
  };

  return (
    <TransitionPage>
      <GenericMetadata
        title={siteMetaData.title}
        description={siteMetaData.description}
        keywords={siteMetaData.keywords}
      />
      <SectionPageWrapper className={'page--collections'} bgColor={'#BBDCD5'}>
        {!data ? <LoadingIcon /> : <CollectionViewCollection collectionData={getCardDataFromCollection(data)} />}
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageShare;
